import { cardsData } from '@/mocks/homeData';

const badgeStyles: Record<string, string> = {
  '重磅': 'bg-primary-500 text-white',
  '独家': 'bg-accent-500 text-white',
  '热': 'bg-accent-400 text-white',
  '争议': 'bg-secondary-500 text-white',
};

const cardImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20photography%20with%20warm%20crimson%20and%20dark%20tones%2C%20stage%20spotlight%20concept%20with%20dramatic%20shadows%2C%20talent%20show%20audition%20atmosphere%2C%20minimalist%20composition%20with%20strong%20contrast%2C%20no%20people%20no%20text%2C%20magazine%20feature%20style&width=800&height=600&seq=card-1-911&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20film%20set%20atmosphere%20with%20warm%20amber%20lighting%2C%20director%20chair%20silhouette%20concept%2C%20movie%20production%20drama%20mood%2C%20soft%20haze%20and%20grain%20texture%2C%20editorial%20photography%20style%2C%20no%20people%20no%20text&width=800&height=600&seq=card-2-911&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Luxurious%20abstract%20composition%20with%20warm%20gold%20and%20crimson%20tones%2C%20fashion%20magazine%20aesthetic%2C%20soft%20silk%20texture%20and%20elegant%20folds%2C%20high%20end%20editorial%20photography%2C%20sophisticated%20lighting%2C%20no%20people%20no%20text&width=800&height=600&seq=card-3-911&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20atmosphere%20with%20warm%20desk%20lamp%20lighting%2C%20legal%20documents%20concept%2C%20confidential%20file%20folders%20and%20contracts%20mood%2C%20low%20key%20editorial%20photography%2C%20mysterious%20noir%20style%2C%20no%20people%20no%20text&width=800&height=600&seq=card-4-911&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20atmosphere%20with%20dramatic%20warm%20lighting%2C%20stage%20equipment%20and%20camera%20silhouettes%2C%20behind%20the%20scenes%20production%20concept%2C%20cinematic%20documentary%20style%2C%20moody%20contrast%2C%20no%20people%20no%20text&width=800&height=600&seq=card-5-911&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Music%20studio%20atmosphere%20with%20warm%20crimson%20and%20amber%20lighting%2C%20vinyl%20record%20and%20sheet%20music%20concept%2C%20creative%20artistic%20composition%2C%20soft%20glow%20and%20texture%2C%20editorial%20photography%20style%2C%20no%20people%20no%20text&width=800&height=600&seq=card-6-911&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Dark%20financial%20office%20atmosphere%20with%20warm%20low%20key%20lighting%2C%20banking%20documents%20and%20ledger%20concept%2C%20corporate%20scandal%20mood%2C%20mysterious%20noir%20photography%20style%2C%20strong%20shadows%2C%20no%20people%20no%20text&width=800&height=600&seq=card-7-911&orientation=landscape',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1200px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-600 bg-primary-100 rounded-full mb-3">
            每日更新
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">精选猛料</h2>
          <p className="mt-2 text-sm text-foreground-600">编辑部精选的最值得关注的独家爆料</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardsData.slice(0, 6).map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={cardImages[item.id]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-0.5 text-[10px] font-semibold bg-black/70 text-white rounded">
                    {item.category}
                  </span>
                  {item.badge && (
                    <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded ${badgeStyles[item.badge] || ''}`}>
                      {item.badge}
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-bold text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {item.excerpt}
                </p>
                <div className="flex items-center justify-between text-[11px] text-foreground-500 pt-3 border-t border-background-200/60">
                  <span>{item.author}</span>
                  <span>{item.time}</span>
                </div>
              </div>
            </a>
          ))}

          <a
            href="#cards"
            className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer flex flex-col"
          >
            <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
              <img
                src={cardImages[7]}
                alt={cardsData[6].title}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 flex items-center gap-2">
                <span className="px-2 py-0.5 text-[10px] font-semibold bg-black/70 text-white rounded">
                  {cardsData[6].category}
                </span>
                {cardsData[6].badge && (
                  <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded ${badgeStyles[cardsData[6].badge] || ''}`}>
                    {cardsData[6].badge}
                  </span>
                )}
              </div>
            </div>
            <div className="p-4 flex-1 flex flex-col">
              <h3 className="text-sm md:text-base font-bold text-foreground-800 leading-snug line-clamp-2 hover:text-primary-500 transition-colors mb-2">
                {cardsData[6].title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3 flex-1">
                {cardsData[6].excerpt}
              </p>
              <div className="flex items-center justify-between text-[11px] text-foreground-500 pt-3 border-t border-background-200/60">
                <span>{cardsData[6].author}</span>
                <span>{cardsData[6].time}</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}